export const bookingConfig = {
	capacities: [
		{ label: '2', value: '2-2' },
		{ label: '3', value: '3-3' },
		{ label: '4', value: '4-4' },
		{ label: '6', value: '6-6' },
		{ label: '8', value: '8-8' },
		{ label: '10', value: '10-10' },
		{ label: '12', value: '12-12' },
		{ label: '14', value: '14-14' },
		{ label: '16+', value: '16-' },
	],
	earlyRebate: {
		code: 'promotion.early_booking',
		days: 30,
		percent: 10,
	},
	hours: { max: 23, min: 8 },
	months: 12,
	recurring: {
		config: {
			maxDays: 2,
			minDays: 1,
		},
		offers: [
			{
				billedHours: 8,
				daysPerWeek: 1,
				rebate: 0.6,
			},
			{
				billedHours: 8,
				daysPerWeek: 2,
				rebate: 0.65,
			},
		],
		typeformRecurringBookingURL: {
			pricingSection: 'https://cocoonspace.typeform.com/to/updKKFB7',
			sidebar: 'https://cocoonspace.typeform.com/to/mjSNTPuw',
		},
	},
	warningTimeout: 5,
	weekDailyHours: 8,
	weekendDailyHours: 6,
} as const

export const BOOKING_CONFIG = bookingConfig
